/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbInputModule,
  NbCheckboxModule,
  NbIconModule,
  NbButtonModule,
} from '@nebular/theme';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgxPrintModule } from 'ngx-print';
import { registerLocaleData } from '@angular/common';
import { LoginComponent } from './shared/components/login/login.component';
// import localeEn from '@angular/common/locales/en';
// import localeEnExtra from '@angular/common/locales/extra/en';

// registerLocaleData(localeEn, 'en-US', localeEnExtra);
import { AgGridModule } from 'ag-grid-angular';
// import "ag-grid-enterprise";
import { environment } from '../environments/environment';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { Router } from '@angular/router';
import {NgxImageCompressService} from 'ngx-image-compress';

@NgModule({
  declarations: [AppComponent,LoginComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),

    TranslateModule.forRoot({
      
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NbSidebarModule,
    FormsModule,
    NbInputModule,
    NbCheckboxModule,
    NbIconModule,
    NbButtonModule,
    NgxPrintModule,
    NbInputModule,
    AgGridModule.withComponents({}),
    CKEditorModule

  ],
  providers:[
    {
      provide: ErrorHandler,
 
    },
    NgxImageCompressService

  ],
  bootstrap: [AppComponent],
})

export class AppModule {
  constructor(private translate: TranslateService) {
    translate.addLangs(['ar', 'en']);
    translate.setDefaultLang(localStorage.getItem('language') || (this.translate.getBrowserLang() == 'ar' || this.translate.getBrowserLang() == 'en' ? this.translate.getBrowserLang() : 'en'));
    translate.use(localStorage.getItem('language') || (this.translate.getBrowserLang() == 'ar' || this.translate.getBrowserLang() == 'en' ? this.translate.getBrowserLang() : 'en'));
}
}
